module.exports = __webpack_public_path__ + "img/emoji/raugh.93ee75800ff668f2bae5b43d143ee2b2.png";